<template>
  <div class="spo-card pa-2 rounded my-2">
    <v-row>
      <v-col>
        <div class="d-flex justify-start flex-wrap gap">
          <div class="text-h5 font-weight-bold">
            {{ pack.nom }}
          </div>
        </div>
        <div class="d-flex flex-wrap justify-start align-center sm-gap my-1">
          <div class="text-body-2 bg-white px-2 py-1 rounded shadowed" v-for="liaison_course in pack.list_liaisons"
            :key="liaison_course.id"><v-icon icon="mdi-check" color="primary" size="xs-small"></v-icon> {{
              liaison_course.nom_course }}</div>
        </div>
      </v-col>

      <v-col cols="12" lg="3" xl="2" class="d-flex flex-column">
        <div v-if="show_inscription_button">
          <SportipsButton @onClick="addToPreselection(pack)" icon="mdi-pencil-plus-outline" chevron action-button
            mobile-full-width>
            S'inscrire
          </SportipsButton>
          <TarifsPack :pack="pack"></TarifsPack>
        </div>
        <div v-else
          class="d-flex align-center justify-center ga-1 bg-dark-red text-white rounded py-2 px-1 font-weight-600 cursor-disabled">
          <v-icon icon="mdi-pencil-off-outline"></v-icon>
          Inscriptions closes
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import TarifsPack from "@/components/Home/Packs/Tarifs_Pack.vue";
export default {
  props: ["pack"],
  components: { TarifsPack },
  computed: {
    ...mapStores(useMainStore),
    // Vérifie si un pack est ouvert aux inscriptions en fonction des courses dont il dépent.
    show_inscription_button() {
      if (this.mainStore.module.status == 'avant_ouverture') {
        return false;
      }
      else if (this.mainStore.module.status == 'apres_fermeture') {
        return false;
      }
      return (this.pack_ouvert && this.mainStore.module.status == 'ouverte') || this.mainStore.view_as_admin || this.mainStore.inscription_as_admin
    },
    pack_ouvert() {
      let courses = this.mainStore.module.courses;
      for (let i = 0; i < this.pack.list_liaisons.length; i++) {
        let liaison = this.pack.list_liaisons[i];
        for (let j = 0; j < courses.list.length; j++) {
          if (courses.list[j].id == liaison.id_course && (courses.list[j].ouvert == "0" || courses.list[j].is_complet(courses))) {

            return false;
          }
        }
      }
      return true;
    },
  },
  methods: {
    /* Si clic sur button _s'inscrire_ on ajoute en mémoire la préselection pour l'ajouter à la sélection de parcours du premier coureur en page suivante */
    addToPreselection(pack) {
      this.mainStore.bookingSystem.preselection = { type: "pack", value: pack.id };

      this.$router.push({ name: "Inscriptions" });
    },
  },
};
</script>

<style lang="scss" scoped></style>